import React from 'react';
import { Box, Divider, InputBase, FormControl, Select, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';

export const SearchBarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: 0,
  maxWidth: '927px',
  margin: '40px auto 0',
  gap: '60px',
  width: 'calc(100% - 40px)',
  [theme.breakpoints.down('md')]: {
    gap: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    margin: '15px auto 0',
  },
}));

export const SearchBarBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 20px',
  maxWidth: '670px',
  width: '75%',
  height: '50px',
  border: '1px solid',
  backgroundColor: '#ffffff',
  borderRadius: '25px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '0 15px',
  },
}));

export const SearchBarInputBase = styled(InputBase)(({ theme }) => ({
  flex: 1,
  fontFamily: 'Raleway',
  fontSize: '16px',

  '& input': {
    // padding: '0 10px',
    padding: '0',
    height: '50px',
    lineHeight: '50px',
    // '&:focus': {
    //   padding: '0',
    // },
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
    },
  },
  '& input::placeholder': {
    padding: '0 10px',
    whiteSpace: 'normal',
    // position: 'absolute',
    // transform: 'translateY(-50%)',
    // WebkitTransform: 'translateY(-50%)',
    WebkitAlignSelf: 'center',
    alignSelf: 'center',
    verticalAlign: 'middle',
    fontSize: '16px',
    lineHeight: '21px!important',
    [theme.breakpoints.between(601, 772)]: {
      position: 'absolute',
      // padding: '3px 10px',
      top: '4px',
    },
    [theme.breakpoints.down(468)]: {
      position: 'absolute',
      // padding: '3px 10px',
      top: '4px',
    },
  },
}));

export const SearchBarDivider = styled(Divider)(() => ({
  borderColor: '#000000',
  height: '30px',
}));

export const LabelTypography = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 400,
  color: '#969696',
  fontFamily: 'Raleway',
}));

export const SearchBarFormControl = styled(FormControl)(({ theme }) => ({
  maxWidth: '130px',
  width: '30%',
  '.MuiOutlinedInput-notchedOutline': { border: 0 },
  boxShadow: 'none',
  [theme.breakpoints.down('sm')]: {
    width: '85px',
  },
}));

export const SearchBarSelect = styled(Select)(({ theme }) => ({
  '&:after': {
    borderBottomColor: '#000000',
  },

  '& .MuiSvgIcon-root': {
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      right: '0',
    },
  },
}));

export const SearchButton = styled(Button)(({ theme }) => ({
  fontWeight: '400',
  lineHeight: '19px',
  borderRadius: 30,
  border: '2px solid #AA9178',
  maxWidth: '160px',
  width: '25%',
  height: '50px',
  color: '#FFFFFF',
  textTransform: 'none',
  fontSize: '18px',
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '150px',
    width: '35%',
    fontSize: '16px',
    margin: '0 auto',
  },
}));

export default function SearchBar() {
  const [city, setCity] = React.useState('');

  const handleChange = (event) => {
    setCity(event.target.value);
  };

  return (
    <SearchBarContainer>
      <SearchBarBox>
        <SearchBarInputBase placeholder="What type of cafes are you looking for?" />
        <SearchBarDivider orientation="vertical" />
        <SearchBarFormControl>
          <SearchBarSelect
            displayEmpty
            value={city}
            label="Label"
            onChange={handleChange}
            inputProps={{ MenuProps: { disableScrollLock: true } }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <LabelTypography>State</LabelTypography>;
              }
              return selected;
            }}
          >
            <MenuItem value="NSW">NSW</MenuItem>
            <MenuItem value="VIC">VIC</MenuItem>
            <MenuItem value="ACT">ACT</MenuItem>
          </SearchBarSelect>
        </SearchBarFormControl>
      </SearchBarBox>
      <SearchButton>Search</SearchButton>
    </SearchBarContainer>
  );
}
